import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
export const calloutsSlice = createSlice({
  name: 'callouts',
  initialState,
  reducers: {}
});
export default calloutsSlice.reducer;
export const selectCallouts = state => state.callouts.list;